<template>
    <v-hover v-slot="{ hover }" open-delay="400">
        <v-navigation-drawer id="core-navigation-drawer" :value="drawer" :permanent="!drawer" :mini-variant="!drawer" app
            :width="!$vuetify.breakpoint.mobile ? '260' : '100%'"
            :expand-on-hover="!drawer && !$vuetify.breakpoint.mobile && hover" @transitionend="onTransitionend">
            <template #prepend>
                <v-img :src="`${publicPath}sp_logo.svg`" v-if="!logoNoText" height="40" style="margin: 12px" contain eager />
                <v-img :src="`${publicPath}sp_logo_no_text.svg`" v-else height="40" style="margin: 12px" contain eager>
                </v-img>
                <v-divider></v-divider>
            </template>

            <template #append>
                <v-scale-transition origin="center" :hide-on-leave="true">
                    <span class="d-flex justify-center" v-if="(hover && !$vuetify.breakpoint.mobile) || drawer">{{
                        $t('newAppVersion') }}</span>
                </v-scale-transition>
            </template>

            <v-list flat class="pt-0">
                <v-list-item-group class="mb-n10">
                    <template v-for="(item, i) in appMenu">
                        <uv-list-group v-if="item.children && item.children.length > 0" :key="`group-${i}`" :item="item"
                            center>
                        </uv-list-group>

                        <uv-list-item v-else :item="item" :key="`item-${i}`" />
                    </template>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </v-hover>
</template>

<script>
// Utilities
import { mapMutations } from "vuex";
import { mdiChartTimeline, mdiFinance, mdiCalendarMultipleCheck, mdiCalendarMultiselectOutline, mdiAccountWrench, mdiCheckCircleOutline, mdiFileSign, mdiFileDocumentOutline, mdiCashMultiple, mdiTruckDelivery, mdiCarSide } from "@mdi/js";

export default {
    name: "AppDrawer",
    data() {
        return {
            logoNoText: true,
            publicPath: process.env.BASE_URL,
            icons: { mdiChartTimeline, mdiFinance, mdiCalendarMultipleCheck, mdiCalendarMultiselectOutline, mdiAccountWrench, mdiCheckCircleOutline, mdiFileSign, mdiFileDocumentOutline, mdiCashMultiple, mdiTruckDelivery, mdiCarSide }
        };
    },
    computed: {
        drawer: {
            get: function () {
                return this.$store.state.drawer;
            },
            set: function (payload) {
                this.setDrawer(payload);
            },
        },
        appMenu: function () {
            let appMenu = [
                {
                    icon: "$uvDashboardOutline",
                    title: this.$t("Dashboard"),
                    to: "/dashboard",
                },
                {
                    icon: '$uvLead',
                    title: this.$t("labels.leads"),
                    to: "/leads"
                },
                {
                    icon: "$proposal",
                    title: this.$t("labels.proposals"),
                    to: "/proposals",
                    color: "primary",
                },
                {
                    icon: "$uvAccountGroup",
                    title: this.$t("clients"),
                    to: "/clients",
                },
                {
                    icon: this.icons.mdiTruckDelivery,
                    title: this.$t('suppliers'),
                    to: "/suppliers"
                },
                {
                    icon: "$uvCarMultiple",
                    title: this.$t("labels.stockConfigurator"),
                    to: "/stock",
                },
                {
                    icon: this.icons.mdiChartTimeline,
                    title: this.$t('reports'),
                    to: "/reports",
                },
                {
                    icon: this.icons.mdiCarSide,
                    title: this.$t('testDrive'),
                    to: "/testdrive"
                },
                {
                    icon: this.icons.mdiFinance,
                    title: this.$t("labels.financial"),
                    to: "/invoices",
                },
                {
                    icon: this.icons.mdiFileSign,
                    title: this.$t('labels.documents'),
                    to: { name: "Documents" }
                },
            ];
            
            return appMenu;
        },
    },
    methods: {
        ...mapMutations({ setDrawer: "SET_drawer", removeApiToken: "REMOVE_apiToken"}),
        close() {
            this.setDrawer(false);
        },
        onShowHide(val) {
            let vm = this;
            if (val) {
                history.pushState(null, null, null);
                window.onpopstate = function () {
                    vm.close();
                };
            } else {
                setTimeout(() => {
                    window.onpopstate = null;
                }, 0);
            }
        },
        onTransitionend(ev) {
            let el = ev.target;

            this.logoNoText = false;
            if (el.classList.contains("v-navigation-drawer--mini-variant")) {
                this.logoNoText = true;
            }
        },
    },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'

#core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
        opacity: .24

    .v-list-item
        &__icon--text,
        &__icon:first-child
            justify-content: center
            text-align: center
            width: 20px

            +ltr()
            margin-right: 24px
            margin-left: 12px !important

            +rtl()
            margin-left: 24px
            margin-right: 12px !important

    .v-list--dense
        .v-list-item
            &__icon--text,
            &__icon:first-child
                margin-top: 10px

    .v-list-group--sub-group
        .v-list-item
            +ltr()
            padding-left: 8px

            +rtl()
            padding-right: 8px

    .v-list-group__header
        +ltr()
        padding-right: 0

        +rtl()
        padding-right: 0

        .v-list-item__icon--text
            margin-top: 19px
            order: 0

        .v-list-group__header__prepend-icon
            order: 2

            +ltr()
            margin-right: 8px

            +rtl()
            margin-left: 8px

    .v-navigation-drawer__content
        display: flex !important
        flex-direction: column !important
        justify-content: space-between !important

    a
        text-decoration: none
    

    .v-navigation-drawer__border
        background-color: rgba(255, 255, 255, 0.3)
    
    .theme--light
        &.v-list-item
            &:not(.v-list-item--active):not(.v-list-item--disabled)
                color: var(--v-uv-primary-base)
            &.v-list-item--active
                background: var(--v-uv-primary-base)
                color: white
                .v-icon, .v-icon__component
                    color: white
    .theme--dark
        &.v-list-item
            &:not(.v-list-item--active):not(.v-list-item--disabled)
                color: white
            &.v-list-item--active
                background: var(--v-uv-primary-base)
                color: white
                .v-icon, .v-icon__component
                    color: white

    .v-navigation-drawer__prepend
        background-color: #fff
    &.v-navigation-drawer--mini-variant
        .v-navigation-drawer__content
            overflow: hidden
</style>
